/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from './authentication-wam/authentication-wam.component.ngfactory';
import * as i2 from '../../app/authentication-wam/user.service';
import * as i3 from '../../app/config/app.config';
import * as i4 from '../../app/authentication-wam/authentication-wam.component';
import * as i5 from '../../app/authentication-wam/authentication-wam.service';
import * as i6 from '@angular/router';
import * as i7 from '@angular/http';
import * as i8 from '../../app/app.component';
const styles_AppComponent:any[] = ([] as any[]);
export const RenderType_AppComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,styles:styles_AppComponent,
    data:{}});
export function View_AppComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),2,'app-authentication-wam',
      ([] as any[]),(null as any),(null as any),(null as any),i1.View_AuthenticationWamComponent_0,
      i1.RenderType_AuthenticationWamComponent)),i0.ɵprd(512,(null as any),i2.UserService,
      i2.UserService,[i3.AppConfig]),i0.ɵdid(114688,(null as any),0,i4.AuthenticationWamComponent,
      [i5.AuthenticationWamService,i6.ActivatedRoute,i6.Router,i7.Http,i2.UserService],
      (null as any),(null as any)),(_l()(),i0.ɵted((null as any),['\n']))],(_ck,_v) => {
    _ck(_v,2,0);
  },(null as any));
}
export function View_AppComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'div',[['gpis-spa',
      '']],(null as any),(null as any),(null as any),View_AppComponent_0,RenderType_AppComponent)),
      i0.ɵdid(49152,(null as any),0,i8.AppComponent,([] as any[]),(null as any),(null as any))],
      (null as any),(null as any));
}
export const AppComponentNgFactory:i0.ComponentFactory<i8.AppComponent> = i0.ɵccf('[gpis-spa]',
    i8.AppComponent,View_AppComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiQzovVXNlcnMvU0hSNk0zL0RldmVsb3BtZW50L1BhY2tJVFdlYkd1aS9zcmMvYXBwL2FwcC5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vQzovVXNlcnMvU0hSNk0zL0RldmVsb3BtZW50L1BhY2tJVFdlYkd1aS9zcmMvYXBwL2FwcC5jb21wb25lbnQudHMiLCJuZzovLy9DOi9Vc2Vycy9TSFI2TTMvRGV2ZWxvcG1lbnQvUGFja0lUV2ViR3VpL3NyYy92aWV3cy9tYXN0ZXJwYWdlLmh0bWwiLCJuZzovLy9DOi9Vc2Vycy9TSFI2TTMvRGV2ZWxvcG1lbnQvUGFja0lUV2ViR3VpL3NyYy9hcHAvYXBwLmNvbXBvbmVudC50cy5BcHBDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8YXBwLWF1dGhlbnRpY2F0aW9uLXdhbT48L2FwcC1hdXRoZW50aWNhdGlvbi13YW0+XHJcbiIsIjxkaXYgZ3Bpcy1zcGE+PC9kaXY+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O29CQ0FBO01BQUE7OENBQUE7cUJBQUEsdUJBQUE7TUFBQTtNQUFBLDZCQUFpRDtJQUFqRDs7OztvQkNBQTtNQUFBO2FBQUE7Ozs7In0=



// WEBPACK FOOTER //
// C:/Users/SHR6M3/Development/PackITWebGui/src/$$_gendir/app/app.component.ngfactory.ts